import React from "react";
import { Sparkles } from "lucide-react";

export const PremiumPill = ({ active = false, size = "sm", labelActive, labelInactive }) => {
  const cls = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid="premium-pill"
      className={`inline-flex items-center gap-1 rounded-full border font-semibold uppercase tracking-wider ${cls} ${
        active
          ? "border-amber-400/60 bg-navy text-amber-300 shadow-[0_0_10px_rgba(251,191,36,0.25)]"
          : "border-amber-300/60 bg-amber-50 text-amber-700"
      }`}
    >
      <Sparkles size={size === "sm" ? 10 : 12} />
      {active ? (labelActive || "Premium active") : (labelInactive || "Premium")}
    </span>
  );
};
